import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../../app/store";
import { KeyManager } from "../../../../api/controlPlaneApi";
import { getBytesNumber } from "common/utils";
import { kmsRpc } from "api";
import { HttpResponse } from "api/observeApi";
import {
  setErrorSnackBarMessage,
  setSnackBarMessage,
} from "screens/systemSlice";
import { errorToHandler } from "api/error";

export const addKMSAsync = createAsyncThunk(
  "KMS/addKMSAsync",
  async (_, { getState, rejectWithValue, dispatch }) => {
    const state = getState() as RootState;

    const selectedSite = state.addKMS.selectedSite;
    const name = state.addKMS.name;
    const namespace = state.addKMS.namespace;
    const volumeSize = state.addKMS.volumeSize;
    const storageClass = state.addKMS.storageClass;
    const sizeFactor = state.addKMS.sizeFactor;
    const replicas = state.addKMS.replicas;
    const expose = state.addKMS.expose;
    const imageName = state.addKMS.imageName;
    const volumeName = state.addKMS.volumeName;

    const currentSize = getBytesNumber(volumeSize, sizeFactor, true);

    return kmsRpc.api
      .addKeyManager(selectedSite, {
        name,
        namespace,
        volumeSize: `${currentSize}`,
        storageClass,
        replicas: parseInt(replicas),
        expose,
        imageName,
        volumeName,
      })
      .then((res: HttpResponse<KeyManager>) => {
        dispatch(setSnackBarMessage("Added KMS Deployment successfully"));
        return res.data;
      })
      .catch((err: any) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(err);
      });
  },
);
